export default {"src":"/_next/static/media/baby_40.ff3a5fdc.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};